import { render, staticRenderFns } from "./createRol.vue?vue&type=template&id=5f9bf6c8&"
import script from "./createRol.vue?vue&type=script&lang=js&"
export * from "./createRol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports